// extracted by mini-css-extract-plugin
module.exports = {"bottomSpacing":"CriteriaStep_bottomSpacing__3Vbal","possiblePointsText":"CriteriaStep_possiblePointsText__3hru_"};